// extracted by mini-css-extract-plugin
export default {"nav":"DefaultPageLayout_nav__WXiXP","wrap":"DefaultPageLayout_wrap__qLokK","content":"DefaultPageLayout_content__9xfIq"};